import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl2;

const service = 'smartdevice';

class SmartDeviceService extends ServiceBase {
    /**
     * get device sections
     *
     * @returns  list of device sections aka Office , Kitchen
     */
    getSections = () => {
        var url = `${baseUrl}/${service}/device/sections`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * get device settings
     *
     * @returns  list of device settings
     */
    getSettings = () => {
        var url = `${baseUrl}/${service}/device/settings`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * Post device settings (insert/update one plug)
     * @param {object} dto - { @desc, rk, name, alias, mac, ip, deviceClass, gname, section, parentRK, active }
     * @returns {Promise}
     */
    postSettings = (dto) => {
        const url = `${baseUrl}/${service}/device/settings`;
        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: dto }, cfg);
    };

    /**
     * Post device` command
     * string deviceName aka tapo-10, Media Living (pc audio),
     * string operation 'SetSwitch' | 'SetLed'
     * string parameter 'true' | 'false'
     * @param {object} dto - { data : {  deviceName, operation, value} }
     * @returns {Promise}
     */
    postDeviceCommand = (dto) => {
        const url = `${baseUrl}/smartdevice/device/command`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: dto }, config);
    };
}

const smartDeviceService = new SmartDeviceService();
export default smartDeviceService;
